module.exports = __webpack_public_path__ + "img/privat-mini.72c26f05.png";